import App from "./App";
import { useLocation } from "react-router-dom";

const AppContainer = () => {
  const location = useLocation();

  return (
    <>
      <App />
    </>
  );
};

export default AppContainer;